export default __webpack_public_path__ + "static/media/projeto4.c4ea79b4.PNG";